<template>
  <div>
    <div v-if="loading">
      <loader></loader>
    </div>
    <div id="canvas">
      <img class="previous-page" src="../../img/left.svg" value="previous" @click="pagePrev" />
      <img class="next-page" src="../../img/right.svg" value="next" @click="pageNext" />
      <div class="flipbook-viewport">
        <div class="col-auto float-left bar">
          <router-link style="padding-right: 90px" to="/home">Kiosk</router-link>
          <a to v-if="!index" @click="cambiarEstado('/index')">Index</a>
          <a to="/index" v-else @click="cambiarEstado('')">Close</a>
        </div>
        <div class="col-auto float-right">
          <a class="zoom-icon zoom-icon-in">Fullscreen</a>
        </div>
        <div class="container">
          <div class="flipbook" @keyup.right="pause" @keyup.left="pause" @click="pause">
            <div :style="'background-image:url(' + pages6[0] + ')'">
              <a
                @click.stop="
                  audioI6.isPlaying == true ? pauseCover(audioI6) : playCover(audioI6)
                "
              >
                <img
                  v-if="audioI6.isPlaying == true"
                  class="cover-button"
                  src="../../img/pause.png"
                />
                <img
                  v-if="audioI6.isPlaying == false"
                  class="cover-button"
                  src="../../img/play.png"
                />
              </a>
            </div>
            <div :style="'background-image:url(' + pages6[1] + ')'"></div>
            <div :style="'background-image:url(' + pages6[2] + ')'"></div>
            <div :style="'background-image:url(' + pages6[3] + ')'"></div>
            <div :style="'background-image:url(' + pages6[4] + ')'"></div>
            <div :style="'background-image:url(' + pages6[5] + ')'"></div>
            <div :style="'background-image:url(' + pages6[6] + ')'"></div>
            <div :style="'background-image:url(' + pages6[7] + ')'"></div>
            <div :style="'background-image:url(' + pages6[8] + ')'"></div>
            <div :style="'background-image:url(' + pages6[9] + ')'"></div>
            <div :style="'background-image:url(' + pages6[10] + ')'"></div>
            <div :style="'background-image:url(' + pages6[11] + ')'"></div>
            <div :style="'background-image:url(' + pages6[12] + ')'"></div>
            <div :style="'background-image:url(' + pages6[13] + ')'"></div>
            <div :style="'background-image:url(' + pages6[14] + ')'"></div>
            <div :style="'background-image:url(' + pages6[15] + ')'"></div>
            <div :style="'background-image:url(' + pages6[16] + ')'"></div>
            <div :style="'background-image:url(' + pages6[17] + ')'"></div>
            <div :style="'background-image:url(' + pages6[18] + ')'"></div>
            <div :style="'background-image:url(' + pages6[19] + ')'"></div>
            <div :style="'background-image:url(' + pages6[20] + ')'"></div>
            <div :style="'background-image:url(' + pages6[21] + ')'"></div>
            <div :style="'background-image:url(' + pages6[22] + ')'"></div>
            <div :style="'background-image:url(' + pages6[23] + ')'"></div>
            <div :style="'background-image:url(' + pages6[24] + ')'"></div>
            <div :style="'background-image:url(' + pages6[25] + ')'"></div>
            <div :style="'background-image:url(' + pages6[26] + ')'"></div>
            <div :style="'background-image:url(' + pages6[27] + ')'"></div>
            <div :style="'background-image:url(' + pages6[28] + ')'"></div>
            <div :style="'background-image:url(' + pages6[29] + ')'"></div>
            <div :style="'background-image:url(' + pages6[30] + ')'"></div>
            <div :style="'background-image:url(' + pages6[31] + ')'"></div>
            <div :style="'background-image:url(' + pages6[32] + ')'"></div>
            <div :style="'background-image:url(' + pages6[33] + ')'"></div>
            <div :style="'background-image:url(' + pages6[34] + ')'"></div>
            <div :style="'background-image:url(' + pages6[35] + ')'"></div>
            <div :style="'background-image:url(' + pages6[36] + ')'"></div>
            <div :style="'background-image:url(' + pages6[37] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 15.4%; left: 6.6%; width: 9%"
                target="_blank"
                @click="openLink('https://www.instagram.com/abeyoon/?hl=en')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[38] + ')'"></div>
            <div :style="'background-image:url(' + pages6[39] + ')'">
              <a
                class="minilinks articles2"
                style="top: 32.2%; right: 6.6%; width: 9%"
                target="_blank"
                @click="openLink('https://www.svnrshop.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="top: 32.2%; left: 50.6%; width: 11%"
                target="_blank"
                @click="openLink('https://yanyanknits.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 21.9%; right: 12.9%; width: 5%"
                target="_blank"
                @click="openLink('https://www.icicle.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.2%; right: 5.6%; width: 10%"
                target="_blank"
                @click="openLink('https://www.sunniesface.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.3%; left: 43.8%; width: 10.6%"
                target="_blank"
                @click="openLink('https://yourparade.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="top: 46.4%; left: 23.5%; width: 7.6%"
                target="_blank"
                @click="openLink('https://www.zouxou.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 27.2%; left: 51%; width: 7.2%"
                target="_blank"
                @click="openLink('https://xuyoni.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[40] + ')'">
              <a
                class="minilinks articles2"
                style="top: 39.4%; left:35.2%; width: 6.6%"
                target="_blank"
                @click="openLink('https://makua.co/ ')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="top: 26.8%; right: 36.9%; width:7%"
                target="_blank"
                @click="openLink('https://www.jwpei.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.2%; right: 16%; width: 10%"
                target="_blank"
                @click="openLink('https://angelchang.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.2%; right: 43.6%; width: 11%"
                target="_blank"
                @click="openLink('https://yanyanknits.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 14.6%; left: 12%; width: 13%"
                target="_blank"
                @click="openLink('https://industrieafrica.com/collections/iamisigo')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 41.5%; left: 48.8%; width: 10%"
                target="_blank"
                @click="openLink('http://www.mozhmozh.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[41] + ')'">
              <a
                class="minilinks articles2"
                style="top: 32.2%; left: 36.8%; width: 14.6%"
                target="_blank"
                @click="openLink('https://www.brooklyngrooming.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="top: 41.1%; right: 13.4%; width: 22%"
                target="_blank"
                @click="openLink('https://www.instagram.com/rahemurrahman/?hl=en')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 27.2%; right: 5%; width: 9%"
                target="_blank"
                @click="openLink('https://livingkoa.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.2%; right: 23%; width: 12.6%"
                target="_blank"
                @click="openLink('https://paperprojectny.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.2%; left: 32%; width: 11%"
                target="_blank"
                @click="openLink('https://www.isseymiyake.com/en/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 27.2%; left: 42%; width: 11.4%"
                target="_blank"
                @click="openLink('https://ahluwalia.world/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[42] + ')'">
              <a
                class="minilinks articles2"
                style="top: 32.1%; left: 38.8%; width: 11.2%"
                target="_blank"
                @click="openLink('https://www.saltandstone.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="top: 34%; right: 18%; width: 9.8%"
                target="_blank"
                @click="openLink('https://www.bonnieclyde.la/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.3%; right: 57.2%; width: 9.8%"
                target="_blank"
                @click="openLink('https://nisaitoyou.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.3%; left: 6%; width: 9.8%"
                target="_blank"
                @click="openLink('https://www.sayebrand.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 30.8%; left: 21%; width: 11.6%"
                target="_blank"
                @click="openLink('https://wearechance.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="top: 39.2%; left: 10.2%; width: 11.6%"
                target="_blank"
                @click="openLink('https://ahluwalia.world/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[43] + ')'"></div>
            <div :style="'background-image:url(' + pages6[44] + ')'"></div>
            <div :style="'background-image:url(' + pages6[45] + ')'"></div>
            <div :style="'background-image:url(' + pages6[46] + ')'"></div>
            <div :style="'background-image:url(' + pages6[47] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.6%; right: 30.4%; width: 14%"
                target="_blank"
                @click="openLink('https://www.robertwun.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[48] + ')'"></div>
            <div :style="'background-image:url(' + pages6[49] + ')'"></div>
            <div :style="'background-image:url(' + pages6[50] + ')'"></div>
            <div :style="'background-image:url(' + pages6[51] + ')'"></div>
            <div :style="'background-image:url(' + pages6[52] + ')'"></div>
            <div :style="'background-image:url(' + pages6[53] + ')'"></div>
            <div :style="'background-image:url(' + pages6[54] + ')'"></div>
            <div :style="'background-image:url(' + pages6[55] + ')'"></div>
            <div :style="'background-image:url(' + pages6[56] + ')'"></div>
            <div :style="'background-image:url(' + pages6[57] + ')'"></div>
            <div :style="'background-image:url(' + pages6[58] + ')'"></div>
            <div :style="'background-image:url(' + pages6[59] + ')'"></div>
            <div :style="'background-image:url(' + pages6[60] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.8%; left: 54.2%; width: 20.5%"
                target="_blank"
                @click="openLink('https://lukhanyomdingi.co.za/')"
              >click</a>
            </div>
            <div :style="'background-image:url(' + pages6[61] + ')'"></div>
            <div :style="'background-image:url(' + pages6[62] + ')'"></div>
            <div :style="'background-image:url(' + pages6[63] + ')'"></div>
            <div :style="'background-image:url(' + pages6[64] + ')'"></div>
            <div :style="'background-image:url(' + pages6[65] + ')'"></div>
            <div :style="'background-image:url(' + pages6[66] + ')'"></div>
            <div :style="'background-image:url(' + pages6[67] + ')'"></div>
            <div :style="'background-image:url(' + pages6[68] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.6%; right: 29.2%; width: 16.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/kentoutsubo/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[69] + ')'"></div>
            <div :style="'background-image:url(' + pages6[70] + ')'"></div>
            <div :style="'background-image:url(' + pages6[71] + ')'"></div>
            <div :style="'background-image:url(' + pages6[72] + ')'"></div>
            <div :style="'background-image:url(' + pages6[73] + ')'"></div>
            <div :style="'background-image:url(' + pages6[74] + ')'"></div>
            <div :style="'background-image:url(' + pages6[75] + ')'">
              <a
                class="links articles2"
                style="bottom: 10.4%; right: 29.2%; width: 15.2%"
                target="_blank"
                @click="openLink('https://www.khiry.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 7.6%; right: 27.2%; width: 17.2%"
                target="_blank"
                @click="openLink('https://mateonewyork.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[76] + ')'"></div>
            <div :style="'background-image:url(' + pages6[77] + ')'"></div>
            <div :style="'background-image:url(' + pages6[78] + ')'"></div>
            <div :style="'background-image:url(' + pages6[79] + ')'"></div>
            <div :style="'background-image:url(' + pages6[80] + ')'"></div>
            <div :style="'background-image:url(' + pages6[81] + ')'"></div>
            <div :style="'background-image:url(' + pages6[82] + ')'">
              <a
                class="links articles2"
                style="top: 18.4%; right: 34.5%; width: 10.5%"
                target="_blank"
                @click="openLink('https://twitter.com/aliiseenm')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[83] + ')'"></div>
            <div :style="'background-image:url(' + pages6[84] + ')'"></div>
            <div :style="'background-image:url(' + pages6[85] + ')'"></div>
            <div :style="'background-image:url(' + pages6[86] + ')'"></div>
            <div :style="'background-image:url(' + pages6[87] + ')'"></div>
            <div :style="'background-image:url(' + pages6[88] + ')'"></div>
            <div :style="'background-image:url(' + pages6[89] + ')'"></div>
            <div :style="'background-image:url(' + pages6[90] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.6%; right: 28.6%; width: 17.2%"
                target="_blank"
                @click="openLink('https://www.vibecalledtech.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[91] + ')'">
              <div class="musicMachines1">
                <vue-player
                  ref="video1"
                  id="musicMachines1"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-6%2Fmedia%2Fpg090_Music_Of_Machines_video.mp4?alt=media&token=8f0e1c2e-f678-4872-8698-90058372e81a"
                  :poster="media[120]"
                ></vue-player>
              </div>

              <a
                class="links articles2"
                style="position:absolute;bottom:25%;left:81.5%;width:14%;font-size:0.7em;border-bottom:none !important;"
                @click.prevent="playMusicMachines1"
              >Click To Play</a>
            </div>
            <div :style="'background-image:url(' + pages6[92] + ')'"></div>
            <div :style="'background-image:url(' + pages6[93] + ')'"></div>
            <div :style="'background-image:url(' + pages6[94] + ')'"></div>
            <div :style="'background-image:url(' + pages6[95] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; right: 22%; width: 22.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/electronicosfantasticos/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[96] + ')'">
              <div class="music2">
                <vue-player
                  ref="video2"
                  id="music2"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-6%2Fmedia%2Fpg095_Music_Of_Machines_video.m4v?alt=media&token=780fea95-2135-4877-b8cd-d40c95109d27"
                  :poster="media[121]"
                ></vue-player>
              </div>
              <a
                class="links articles2"
                style="position: absolute;bottom: 25%;left: 81%;width: 14%;font-size: 0.7em;border-bottom: none !important;"
                @click.prevent="playMusicMachines2"
              >Click To Play</a>
            </div>
            <div :style="'background-image:url(' + pages6[97] + ')'"></div>
            <div :style="'background-image:url(' + pages6[98] + ')'"></div>
            <div :style="'background-image:url(' + pages6[99] + ')'">
              <a
                class="links articles2"
                style="top: 33.8%; left: 6.8%; width: 13.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/soshecan_/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[100] + ')'"></div>
            <div :style="'background-image:url(' + pages6[101] + ')'"></div>
            <div :style="'background-image:url(' + pages6[102] + ')'"></div>
            <div :style="'background-image:url(' + pages6[103] + ')'"></div>
            <div :style="'background-image:url(' + pages6[104] + ')'"></div>
            <div :style="'background-image:url(' + pages6[105] + ')'"></div>
            <div :style="'background-image:url(' + pages6[106] + ')'"></div>
            <div :style="'background-image:url(' + pages6[107] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; right: 30.8%; width: 13.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/yvetteyoung/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[108] + ')'">
              <div class="midwest">
                <vue-player
                  ref="video3"
                  id="midwest"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-6%2Fmedia%2Fpg107_midwest_emooncrackriff_video.mp4?alt=media&token=52a1fc09-6c19-4430-936a-0b22abdeae74"
                  :poster="media[122]"
                ></vue-player>
              </div>
              <a
                class="links articles2"
                style="position: absolute;bottom: 25%;left: 81%;width: 14%;font-size: 0.7em;border-bottom: none !important;"
                @click.prevent="playMidwest"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages6[109] + ')'"></div>
            <div :style="'background-image:url(' + pages6[110] + ')'"></div>
            <div :style="'background-image:url(' + pages6[111] + ')'"></div>
            <div :style="'background-image:url(' + pages6[112] + ')'"></div>
            <div :style="'background-image:url(' + pages6[113] + ')'"></div>
            <div :style="'background-image:url(' + pages6[114] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 54.4%; width: 18.4%"
                target="_blank"
                @click="openLink('https://www.instagram.com/jazmine_wildcat/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[115] + ')'"></div>
            <div :style="'background-image:url(' + pages6[116] + ')'"></div>
            <div :style="'background-image:url(' + pages6[117] + ')'"></div>
            <div :style="'background-image:url(' + pages6[118] + ')'"></div>
            <div :style="'background-image:url(' + pages6[119] + ')'"></div>
            <div :style="'background-image:url(' + pages6[120] + ')'"></div>
            <div :style="'background-image:url(' + pages6[121] + ')'"></div>
            <div :style="'background-image:url(' + pages6[122] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; right: 31%; width: 14.6%"
                target="_blank"
                @click="openLink('https://www.instagram.com/quannah.rose/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[123] + ')'"></div>
            <div :style="'background-image:url(' + pages6[124] + ')'">
              <a
                class="links articles2"
                style="bottom: 53.8%; right: 30.8%; width: 15%"
                target="_blank"
                @click="openLink('https://www.instagram.com/archikadogra/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[125] + ')'"></div>
            <div :style="'background-image:url(' + pages6[126] + ')'"></div>
            <div :style="'background-image:url(' + pages6[127] + ')'"></div>
            <div :style="'background-image:url(' + pages6[128] + ')'"></div>
            <div :style="'background-image:url(' + pages6[129] + ')'"></div>
            <div :style="'background-image:url(' + pages6[130] + ')'"></div>
            <div :style="'background-image:url(' + pages6[131] + ')'"></div>
            <div :style="'background-image:url(' + pages6[132] + ')'"></div>
            <div :style="'background-image:url(' + pages6[133] + ')'">
              <a
                class="links articles2"
                style="bottom: 10.3%; right: 26%; width: 18.5%"
                target="_blank"
                @click="openLink('https://www.greenheffafarms.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 7.7%; right: 30%; width: 14.6%"
                target="_blank"
                @click="openLink('https://www.jubileejustice.org/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[134] + ')'"></div>
            <div :style="'background-image:url(' + pages6[135] + ')'"></div>
            <div :style="'background-image:url(' + pages6[136] + ')'"></div>
            <div :style="'background-image:url(' + pages6[137] + ')'"></div>
            <div :style="'background-image:url(' + pages6[138] + ')'"></div>
            <div :style="'background-image:url(' + pages6[139] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; right: 27.6%; width: 17%"
                target="_blank"
                @click="openLink('https://biteback2030.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[140] + ')'"></div>
            <div :style="'background-image:url(' + pages6[141] + ')'"></div>
            <div :style="'background-image:url(' + pages6[142] + ')'"></div>
            <div :style="'background-image:url(' + pages6[143] + ')'"></div>
            <div :style="'background-image:url(' + pages6[144] + ')'">
              <a
                class="links articles2"
                style="top: 33.8%; right: 35%; width: 10.8%"
                target="_blank"
                @click="openLink('https://www.instagram.com/ashlynso_/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[145] + ')'"></div>
            <div :style="'background-image:url(' + pages6[146] + ')'"></div>
            <div :style="'background-image:url(' + pages6[147] + ')'"></div>
            <div :style="'background-image:url(' + pages6[148] + ')'"></div>
            <div :style="'background-image:url(' + pages6[149] + ')'"></div>
            <div :style="'background-image:url(' + pages6[150] + ')'"></div>
            <div :style="'background-image:url(' + pages6[151] + ')'"></div>
            <div :style="'background-image:url(' + pages6[152] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; right: 31%; width: 14.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/seohyun1018/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[153] + ')'"></div>
            <div :style="'background-image:url(' + pages6[154] + ')'"></div>
            <div :style="'background-image:url(' + pages6[155] + ')'"></div>
            <div :style="'background-image:url(' + pages6[156] + ')'">
              <a
                class="links articles2"
                style="bottom: 10.3%; left: 55%; width: 13.5%"
                target="_blank"
                @click="openLink('https://www.calvinklein.us/en')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[157] + ')'"></div>
            <div :style="'background-image:url(' + pages6[158] + ')'"></div>
            <div :style="'background-image:url(' + pages6[159] + ')'">
              <div class="damson">
                <vue-player
                  ref="video4"
                  id="damson"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-6%2Fmedia%2Fpg158_DamsonIdris_video.mp4?alt=media&token=8e6e52a3-6895-4066-9ad3-a60fb49c852c"
                  :poster="media[123]"
                ></vue-player>
              </div>
              <a
                class="links articles2"
                style="position: absolute;bottom: 23%;left: 80.5%;width: 15%;font-size: 0.8em;border-bottom: none !important;"
                @click.prevent="playDamsonIdris"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages6[160] + ')'"></div>
            <div :style="'background-image:url(' + pages6[161] + ')'"></div>
            <div :style="'background-image:url(' + pages6[162] + ')'"></div>
            <div :style="'background-image:url(' + pages6[163] + ')'"></div>
            <div :style="'background-image:url(' + pages6[164] + ')'"></div>
            <div :style="'background-image:url(' + pages6[165] + ')'"></div>
            <div :style="'background-image:url(' + pages6[166] + ')'">
              <div class="snowfall">
                <vue-player
                  ref="video5"
                  id="snowfall"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-6%2Fmedia%2Fpg165_Snowfall_video.m4v?alt=media&token=d2160e69-e8f5-491d-8456-7cba5346dacd"
                  :poster="media[124]"
                ></vue-player>
              </div>
              <a
                class="links articles2"
                style="position:absolute;bottom:25%;left:81.5%;width:14%;font-size:0.7em;border-bottom:none !important;"
                @click.prevent="playSnowfall"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages6[167] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; right: 30.5%; width: 14%"
                target="_blank"
                @click="openLink('https://www.instagram.com/damsonidris/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[168] + ')'"></div>
            <div :style="'background-image:url(' + pages6[169] + ')'"></div>
            <div :style="'background-image:url(' + pages6[170] + ')'"></div>
            <div :style="'background-image:url(' + pages6[171] + ')'">
              <a
                class="links articles2"
                style="bottom: 25.6%; left: 6.8%; width: 16.2%"
                target="_blank"
                @click="openLink('https://www.instagram.com/perlasngdigma/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[172] + ')'"></div>
            <div :style="'background-image:url(' + pages6[173] + ')'"></div>
            <div :style="'background-image:url(' + pages6[174] + ')'"></div>
            <div :style="'background-image:url(' + pages6[175] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.3%; left: 44.4%; width: 11%"
                target="_blank"
                @click="openLink('https://www.jmpatras.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[176] + ')'"></div>
            <div :style="'background-image:url(' + pages6[177] + ')'"></div>
            <div :style="'background-image:url(' + pages6[178] + ')'"></div>
            <div :style="'background-image:url(' + pages6[179] + ')'">
              <a
                class="links articles2"
                style="bottom: 8.6%; left: 39%; width: 10.6%;"
                target="_blank"
                @click="openLink('https://kyleweeks.co/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[180] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.1%; left: 54%; width: 19.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/hassanhajjaj_larache/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[181] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%; left: 45%; width: 10.5%"
                target="_blank"
                @click="openLink('https://www.gallery1957.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[182] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%; right: 33.7%; width: 20%"
                target="_blank"
                @click="openLink('https://jackshainman.com/artists/lynette_yiadom_boakye')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[183] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%;right: 35.2%;width: 19%;"
                target="_blank"
                @click="openLink('https://arsny.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[184] + ')'">
              <a
                class="links articles2"
                style="bottom: 8.2%; left: 54.8%; width: 14.2%"
                target="_blank"
                @click="openLink('https://addisfineart.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[185] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%; right: 25.8%; width: 10.2%"
                target="_blank"
                @click="openLink('https://salon94.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[186] + ')'">
              <a
                class="links articles2"
                style="bottom: 9%;  left: 35.4%; width: 19.5%;"
                target="_blank"
                @click="openLink('https://jackshainman.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[187] + ')'">
              <a
                class="links articles2"
                style="bottom: 9%; left: 16%; width: 14.2%"
                target="_blank"
                @click="openLink('https://arthurtimothy.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[188] + ')'">
              <a
                class="links articles2"
                style="bottom: 10.2%; left: 28.4%; width: 15%"
                target="_blank"
                @click="openLink('https://www.wolelagunju.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[189] + ')'">
              <a
                class="links articles2"
                style="bottom: 8.2%; left: 29.4%; width: 11%"
                target="_blank"
                @click="openLink('https://silviarosi.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[190] + ')'">
              <a
                class="links articles2"
                style="bottom: 8.2%; left: 53%; width: 20%"
                target="_blank"
                @click="openLink('https://maximillianwilliam.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[191] + ')'">
              <a
                class="links articles2"
                style="bottom: 9%; left: 36%; width: 23%;"
                target="_blank"
                @click="openLink('https://www.stephenfriedman.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[192] + ')'">
              <a
                class="links articles2"
                style="bottom: 12.2%; left: 30.2%; width: 15.5%"
                target="_blank"
                @click="openLink('https://www.solaolulode.co.uk/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[193] + ')'"></div>
            <div :style="'background-image:url(' + pages6[194] + ')'"></div>
            <div :style="'background-image:url(' + pages6[195] + ')'"></div>
            <div :style="'background-image:url(' + pages6[196] + ')'"></div>
            <div :style="'background-image:url(' + pages6[197] + ')'"></div>
            <div :style="'background-image:url(' + pages6[198] + ')'"></div>
            <div :style="'background-image:url(' + pages6[199] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; right: 30.6%; width: 14%"
                target="_blank"
                @click="openLink('https://www.instagram.com/qween_jean/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[200] + ')'"></div>
            <div :style="'background-image:url(' + pages6[201] + ')'"></div>
            <div :style="'background-image:url(' + pages6[202] + ')'">
              <a
                class="links articles2"
                style="bottom: 48.6%; left: 54%; width: 14.2%"
                target="_blank"
                @click="openLink('https://www.instagram.com/vuongdustin/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[203] + ')'"></div>
            <div :style="'background-image:url(' + pages6[204] + ')'"></div>
            <div :style="'background-image:url(' + pages6[205] + ')'"></div>
            <div :style="'background-image:url(' + pages6[206] + ')'"></div>
            <div :style="'background-image:url(' + pages6[207] + ')'"></div>
            <div :style="'background-image:url(' + pages6[208] + ')'"></div>
            <div :style="'background-image:url(' + pages6[209] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 55.6%; width: 12.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/designdain/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[210] + ')'"></div>
            <div :style="'background-image:url(' + pages6[211] + ')'"></div>
            <div :style="'background-image:url(' + pages6[212] + ')'"></div>
            <div :style="'background-image:url(' + pages6[213] + ')'"></div>
            <div :style="'background-image:url(' + pages6[214] + ')'"></div>
            <div :style="'background-image:url(' + pages6[215] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 55.2%; width: 13.5%"
                target="_blank"
                @click="openLink('https://www.yellowface.org/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[216] + ')'"></div>
            <div :style="'background-image:url(' + pages6[217] + ')'"></div>
            <div :style="'background-image:url(' + pages6[218] + ')'"></div>
            <div :style="'background-image:url(' + pages6[219] + ')'"></div>
            <div :style="'background-image:url(' + pages6[220] + ')'"></div>
            <div :style="'background-image:url(' + pages6[221] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 55.4%; width: 20.2%"
                target="_blank"
                @click="openLink('https://www.instagram.com/yalitzaapariciomtz/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[222] + ')'">
              <div class="roma">
                <vue-player
                  ref="video6"
                  id="roma"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-6%2Fmedia%2Fpg221_ROMA_video.mp4?alt=media&token=9c949c93-dde8-4730-af49-db4ff0839f37"
                  :poster="media[125]"
                ></vue-player>
              </div>
              <a
                class="links articles2"
                style="position: absolute;bottom: 25%;left: 81%;width: 14%;font-size: 0.7em;border-bottom: none !important;"
                @click.prevent="playRoma"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages6[223] + ')'"></div>
            <div :style="'background-image:url(' + pages6[224] + ')'"></div>
            <div :style="'background-image:url(' + pages6[225] + ')'"></div>
            <div :style="'background-image:url(' + pages6[226] + ')'"></div>
            <div :style="'background-image:url(' + pages6[227] + ')'"></div>
            <div :style="'background-image:url(' + pages6[228] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 54.2%; width: 25.2%"
                target="_blank"
                @click="openLink('https://carmenmariamachado.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[229] + ')'"></div>
            <div :style="'background-image:url(' + pages6[230] + ')'"></div>
            <div :style="'background-image:url(' + pages6[231] + ')'"></div>
            <div :style="'background-image:url(' + pages6[232] + ')'"></div>
            <div :style="'background-image:url(' + pages6[233] + ')'"></div>
            <div :style="'background-image:url(' + pages6[234] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 54.2%; width: 17.4%"
                target="_blank"
                @click="openLink('https://www.humblethepoet.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[235] + ')'"></div>
            <div :style="'background-image:url(' + pages6[236] + ')'"></div>
            <div :style="'background-image:url(' + pages6[237] + ')'"></div>
            <div :style="'background-image:url(' + pages6[238] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%; left: 31.5%; width: 35%"
                target="_blank"
                @click="openBook"
              >CLICK HERE TO DOWNLOAD</a>
            </div>
            <div :style="'background-image:url(' + pages6[239] + ')'"></div>
            <div :style="'background-image:url(' + pages6[240] + ')'"></div>
            <div :style="'background-image:url(' + pages6[241] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 55.4%; width: 25.4%"
                target="_blank"
                @click="openLink('https://www.instagram.com/juma_harding_dimmock/?hl=en')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[242] + ')'"></div>
            <div :style="'background-image:url(' + pages6[243] + ')'"></div>
            <div :style="'background-image:url(' + pages6[244] + ')'"></div>
            <div :style="'background-image:url(' + pages6[245] + ')'"></div>
            <div :style="'background-image:url(' + pages6[246] + ')'"></div>
            <div :style="'background-image:url(' + pages6[247] + ')'"></div>
            <div :style="'background-image:url(' + pages6[248] + ')'"></div>
            <div :style="'background-image:url(' + pages6[249] + ')'"></div>
            <div :style="'background-image:url(' + pages6[250] + ')'"></div>
            <div :style="'background-image:url(' + pages6[251] + ')'"></div>
            <div :style="'background-image:url(' + pages6[252] + ')'"></div>
            <div :style="'background-image:url(' + pages6[253] + ')'"></div>
            <div :style="'background-image:url(' + pages6[254] + ')'"></div>
            <div :style="'background-image:url(' + pages6[255] + ')'"></div>
            <div :style="'background-image:url(' + pages6[256] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 54.4%; width: 20%"
                target="_blank"
                @click="openLink('https://www.instagram.com/kenidra4humanity/')"
              >clik</a>
            </div>

            <div :style="'background-image:url(' + pages6[257] + ')'"></div>
            <div :style="'background-image:url(' + pages6[258] + ')'"></div>
            <div :style="'background-image:url(' + pages6[259] + ')'"></div>
            <div :style="'background-image:url(' + pages6[260] + ')'"></div>
            <div :style="'background-image:url(' + pages6[261] + ')'"></div>
            <div :style="'background-image:url(' + pages6[262] + ')'"></div>
            <div :style="'background-image:url(' + pages6[263] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 55.5%; width: 20.2%"
                target="_blank"
                @click="openLink('https://www.instagram.com/astronautstarbright/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[264] + ')'"></div>
            <div :style="'background-image:url(' + pages6[265] + ')'"></div>
            <div :style="'background-image:url(' + pages6[266] + ')'"></div>
            <div :style="'background-image:url(' + pages6[267] + ')'">
              <a
                class="links articles2"
                style="bottom: 25.6%; left: 55.4%; width: 19.4%"
                target="_blank"
                @click="openLink('https://www.instagram.com/thereallukechacko/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[268] + ')'"></div>
            <div :style="'background-image:url(' + pages6[269] + ')'"></div>
            <div :style="'background-image:url(' + pages6[270] + ')'"></div>
            <div :style="'background-image:url(' + pages6[271] + ')'"></div>
            <div :style="'background-image:url(' + pages6[272] + ')'"></div>
            <div :style="'background-image:url(' + pages6[273] + ')'"></div>
            <div :style="'background-image:url(' + pages6[274] + ')'"></div>
            <div :style="'background-image:url(' + pages6[275] + ')'"></div>
            <div :style="'background-image:url(' + pages6[276] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 54.2%; width: 11.2%"
                target="_blank"
                @click="openLink('https://www.froskate.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[277] + ')'"></div>
            <div :style="'background-image:url(' + pages6[278] + ')'"></div>
            <div :style="'background-image:url(' + pages6[279] + ')'"></div>
            <div :style="'background-image:url(' + pages6[280] + ')'"></div>
            <div :style="'background-image:url(' + pages6[281] + ')'"></div>
            <div :style="'background-image:url(' + pages6[282] + ')'"></div>
            <div :style="'background-image:url(' + pages6[283] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 55.6%; width: 16.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/hadiqa_bashir/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[284] + ')'"></div>
            <div :style="'background-image:url(' + pages6[285] + ')'"></div>
            <div :style="'background-image:url(' + pages6[286] + ')'"></div>
            <div :style="'background-image:url(' + pages6[287] + ')'"></div>
            <div :style="'background-image:url(' + pages6[288] + ')'"></div>
            <div :style="'background-image:url(' + pages6[289] + ')'"></div>
            <div :style="'background-image:url(' + pages6[290] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 54.4%; width: 10.4%"
                target="_blank"
                @click="openLink('https://www.instagram.com/nuraphd/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[291] + ')'"></div>
            <div :style="'background-image:url(' + pages6[292] + ')'">
              <a
                class="links articles2"
                style="top: 21.1%; left: 54.2%; width: 11.6%"
                target="_blank"
                @click="openLink('https://www.instagram.com/urpalnico/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[293] + ')'"></div>
            <div :style="'background-image:url(' + pages6[294] + ')'"></div>
            <div :style="'background-image:url(' + pages6[295] + ')'">
              <a
                class="links articles2"
                style="bottom: 35.4%; left: 21%; width: 9.4%"
                target="_blank"
                @click="openLink('https://www.calvinklein.us/en')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[296] + ')'"></div>
            <div :style="'background-image:url(' + pages6[297] + ')'"></div>
            <div :style="'background-image:url(' + pages6[298] + ')'"></div>
            <div :style="'background-image:url(' + pages6[299] + ')'"></div>
            <div :style="'background-image:url(' + pages6[300] + ')'"></div>
            <div :style="'background-image:url(' + pages6[301] + ')'"></div>
            <div :style="'background-image:url(' + pages6[302] + ')'"></div>
            <div :style="'background-image:url(' + pages6[303] + ')'"></div>
            <div :style="'background-image:url(' + pages6[304] + ')'"></div>
            <div :style="'background-image:url(' + pages6[305] + ')'"></div>
            <div :style="'background-image:url(' + pages6[306] + ')'"></div>
            <div :style="'background-image:url(' + pages6[307] + ')'"></div>
            <div :style="'background-image:url(' + pages6[308] + ')'"></div>
            <div :style="'background-image:url(' + pages6[309] + ')'">
              <a
                class="links articles2"
                style="bottom: 5.6%; left: 10.8%; width: 7.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/celeste.red/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 11.8%; left: 50.5%; width: 12%"
                target="_blank"
                @click="openLink('https://www.instagram.com/freshwhiteproclub_/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[310] + ')'">
              <a
                class="links articles2"
                style="bottom: 6.9%;left: 51.2%;width: 9%;"
                target="_blank"
                @click="openLink('https://www.instagram.com/sue._.ah/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[311] + ')'"></div>
            <div :style="'background-image:url(' + pages6[312] + ')'"></div>
            <div :style="'background-image:url(' + pages6[313] + ')'"></div>
            <div :style="'background-image:url(' + pages6[314] + ')'">
              <a
                class="links articles2"
                style="bottom: 51.2%; left: 54.4%; width: 19%"
                target="_blank"
                @click="openLink('https://www.instagram.com/sam_schimmel_/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[315] + ')'"></div>
            <div :style="'background-image:url(' + pages6[316] + ')'">
              <a
                class="links articles2"
                style="bottom: 29%; left: 12.9%; width: 5.5%"
                target="_blank"
                @click="openLink('https://www.coach.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 15.6%; left: 12.9%; width: 17%"
                target="_blank"
                @click="openLink('https://www.ralphlauren.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[317] + ')'"></div>
            <div :style="'background-image:url(' + pages6[318] + ')'">
              <a
                class="links articles2"
                style="bottom: 26.8%; left: 9.8%; width: 5.2%"
                target="_blank"
                @click="openLink('https://www.prada.com')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 17.2%; left: 14.2%; width: 5.2%"
                target="_blank"
                @click="openLink('https://www.prada.com')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 9.5%; left: 11.8%; width: 12.8%"
                target="_blank"
                @click="openLink('https://www.celine.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 5.7%; left: 7.5%; width: 5%"
                target="_blank"
                @click="openLink('https://cdlp.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[319] + ')'"></div>
            <div :style="'background-image:url(' + pages6[320] + ')'">
              <a
                class="links articles2"
                style="bottom: 29.5%; right: 7%; width: 10%"
                target="_blank"
                @click="openLink('https://winnienewyork.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 25.7%; right: 20.2%; width: 7%"
                target="_blank"
                @click="openLink('https://www.berluti.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 23.8%; right: 18.6%; width: 8%"
                target="_blank"
                @click="openLink('https://www.converse.com/   ')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 21.9%; right: 15.8%; width: 3.8%"
                target="_blank"
                @click="openLink('https://www.amiparis.com')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 20%; right: 14.8%; width: 6.2%"
                target="_blank"
                @click="openLink('https://zankovstudio.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 18%; right: 7.2%; width: 8%"
                target="_blank"
                @click="openLink('https://www.converse.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 10.2%; right: 7.2%; width: 5%"
                target="_blank"
                @click="openLink('https://www.gucci.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[321] + ')'"></div>
            <div :style="'background-image:url(' + pages6[322] + ')'">
              <a
                class="links articles2"
                style="bottom: 10.3%; right:8.6%; width: 8%"
                target="_blank"
                @click="openLink('https://www.burberry.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[323] + ')'"></div>
            <div :style="'background-image:url(' + pages6[324] + ')'">
              <a
                class="links articles2"
                style="bottom: 24.6%;left: 21.8%;width: 5%;"
                target="_blank"
                @click="openLink('https://us.louisvuitton.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 22.6%;left: 6.8%;width: 7%;"
                target="_blank"
                @click="openLink('https://us.louisvuitton.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 17.6%; left: 10.8%; width: 10%"
                target="_blank"
                @click="openLink('https://us.louisvuitton.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 9.4%;left: 19.3%;width: 9.6%;"
                target="_blank"
                @click="openLink('https://www.celine.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 8.4%; left: 7.3%; width: 9.6%"
                target="_blank"
                @click="openLink('https://www.celine.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[325] + ')'"></div>
            <div :style="'background-image:url(' + pages6[326] + ')'"></div>
            <div :style="'background-image:url(' + pages6[327] + ')'"></div>
            <div :style="'background-image:url(' + pages6[328] + ')'"></div>
            <div :style="'background-image:url(' + pages6[329] + ')'"></div>
            <div :style="'background-image:url(' + pages6[330] + ')'"></div>
            <div :style="'background-image:url(' + pages6[331] + ')'"></div>
            <div :style="'background-image:url(' + pages6[332] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 54%; width: 18%"
                target="_blank"
                @click="openLink('https://khaledbeydoun.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[333] + ')'"></div>
            <div :style="'background-image:url(' + pages6[334] + ')'"></div>
            <div :style="'background-image:url(' + pages6[335] + ')'"></div>
            <div :style="'background-image:url(' + pages6[336] + ')'"></div>
            <div :style="'background-image:url(' + pages6[337] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 55.6%; width: 21%"
                target="_blank"
                @click="openLink('https://www.instagram.com/monicaterezabenicio/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[338] + ')'"></div>
            <div :style="'background-image:url(' + pages6[339] + ')'"></div>
            <div :style="'background-image:url(' + pages6[340] + ')'"></div>
            <div :style="'background-image:url(' + pages6[341] + ')'"></div>
            <div :style="'background-image:url(' + pages6[342] + ')'"></div>
            <div :style="'background-image:url(' + pages6[343] + ')'"></div>
            <div :style="'background-image:url(' + pages6[344] + ')'"></div>
            <div :style="'background-image:url(' + pages6[345] + ')'"></div>
            <div :style="'background-image:url(' + pages6[346] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 54.5%; width: 13.8%"
                target="_blank"
                @click="openLink('https://www.instagram.com/suldaansaid/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[347] + ')'"></div>
            <div :style="'background-image:url(' + pages6[348] + ')'">
              <a
                class="links articles2"
                style="top: 20.9%; left: 54.2%; width: 16%"
                target="_blank"
                @click="openLink('https://www.instagram.com/sophiakianni/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[349] + ')'"></div>
            <div :style="'background-image:url(' + pages6[350] + ')'"></div>
            <div :style="'background-image:url(' + pages6[351] + ')'"></div>
            <div :style="'background-image:url(' + pages6[352] + ')'"></div>
            <div :style="'background-image:url(' + pages6[353] + ')'"></div>
            <div :style="'background-image:url(' + pages6[354] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.7%; left: 54.5%; width: 16%"
                target="_blank"
                @click="openLink('https://www.instagram.com/dr.yusefsalaam/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[355] + ')'">
              <div class="wtsu_left">
                <img :src="media[128]" alt="whenTheySeeUs" height="1250%" width="1250%" />
              </div>
            </div>
            <div :style="'background-image:url(' + pages6[356] + ')'">
              <div class="wtsu_right">
                <img :src="media[129]" alt="whenTheySeeUs" height="1250%" width="1250%" />
              </div>
              <a
                class="links articles2"
                @click="onPlayerReadyWtsu(media[127])"
                style="bottom: 9.5%;left: 59%;width: 18%;font-size: 1.2vw;text-decoration: none;"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages6[357] + ')'"></div>
            <div :style="'background-image:url(' + pages6[358] + ')'"></div>
            <div :style="'background-image:url(' + pages6[359] + ')'"></div>
            <div :style="'background-image:url(' + pages6[360] + ')'">
              <a
                class="links articles2"
                style="bottom: 10.9%; left: 15.5%; width: 6.6%"
                target="_blank"
                @click="openLink('https://www.chanel.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[361] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.3%; left: 54.5%; width: 5.4%"
                target="_blank"
                @click="openLink('https://www.coach.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[362] + ')'">
              <a
                class="links articles2"
                style="bottom: 9.1%; left: 9.5%; width: 12.5%"
                target="_blank"
                @click="openLink('https://simonerocha.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 7.2%; left:14.8%; width: 4.5%"
                target="_blank"
                @click="openLink('https://area.nyc/collections/shoes')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[363] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%; right: 6.2%; width: 11.8%"
                target="_blank"
                @click="openLink('https://www.ralphlauren.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[364] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%; left: 52.2%; width: 8.5%"
                target="_blank"
                @click="openLink('https://www.dior.com')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[365] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 9%; right: 6.2%; width: 9%"
                target="_blank"
                @click="openLink('https://www.balenciaga.com')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[366] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 9%; left: 64%; width: 9%"
                target="_blank"
                @click="openLink('https://www.alexandermcqueen.com')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7%;left: 29%;width: 9%;"
                target="_blank"
                @click="openLink('https://www.alexandermcqueen.com')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[367] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; left: 43.8%; width: 5%"
                target="_blank"
                @click="openLink('https://www.gucci.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[368] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 9%; left: 51%; width: 16%"
                target="_blank"
                @click="openLink('https://doverstreetmarket.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; left: 42%; width: 10%"
                target="_blank"
                @click="openLink('https://www.rickowens.eu')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[369] + ')'">
              <a
                class="minilinks articles2"
                style="top: 9.8%;right: 5.4%;width: 6.8%;"
                target="_blank"
                @click="openLink('https://www.chloe.com')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="top: 13.5%;right: 8.4%;width: 18.8%;"
                target="_blank"
                @click="openLink('https://www.chloe.com/us/backpack_cod45595518we.html?gclid=Cj0KCQiA7oyNBhDiARIsADtGRZbsbO0zC1_NvX49uZ4GVvgijrVGeteDsKoNo1blF153959a9I-sE-IaAqTEEALw_wcB&gclsrc=aw.ds')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[370] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; left: 49%; width: 14%"
                target="_blank"
                @click="openLink('https://www.bottegaveneta.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[371] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 18.5%;right: 6.2%; width: 7.8%"
                target="_blank"
                @click="openLink('https://www.miumiu.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.3%;right: 18.4%; width: 5%"
                target="_blank"
                @click="openLink('https://www.gucci.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[372] + ')'"></div>
            <div :style="'background-image:url(' + pages6[373] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; right: 6.2%; width: 10%"
                target="_blank"
                @click="openLink('https://www.marcjacobs.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[374] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; left: 42%; width: 9%"
                target="_blank"
                @click="openLink('https://www.valentino.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7.2%;left: 64%;width: 13%;"
                target="_blank"
                @click="openLink('https://www.isabelmarant.com')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[375] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; right: 28%; width: 8.5%"
                target="_blank"
                @click="openLink('https://www.dior.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[376] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 11%; left: 18%; width: 7%"
                target="_blank"
                @click="openLink('https://www.balmain.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[377] + ')'">
              <a
                class="links articles2"
                style="bottom: 12.8%; right: 5.8%; width: 9%"
                target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 10.8%;right: 18.8%;width: 9%;"
                target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[378] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; left: 47.5%; width: 9.5%"
                target="_blank"
                @click="openLink('https://www.balenciaga.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[379] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%; right: 6.2%; width: 5.4%"
                target="_blank"
                @click="openLink('https://www.chloe.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[380] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%; left: 22%; width: 27%"
                target="_blank"
                @click="openLink('https://www.celine.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[381] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; right: 16%; width: 13%"
                target="_blank"
                @click="openLink('https://www.bottegaveneta.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[382] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; left: 42.8%; width: 7%"
                target="_blank"
                @click="openLink('https://www.balmain.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[383] + ')'">
              <a
                class="links articles2"
                style="bottom: 16.8%; right: 6%; width: 6.4%"
                target="_blank"
                @click="openLink('https://www.chanel.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7.4%; right: 6%; width: 13.5%"
                target="_blank"
                @click="openLink('https://www.bottegaveneta.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[384] + ')'"></div>
            <div :style="'background-image:url(' + pages6[385] + ')'"></div>
            <div :style="'background-image:url(' + pages6[386] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 12.2%; right: 10.8%; width: 4%"
                target="_blank"
                @click="openLink('https://www.dior.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[387] + ')'"></div>
            <div :style="'background-image:url(' + pages6[388] + ')'"></div>
            <div :style="'background-image:url(' + pages6[389] + ')'"></div>
            <div :style="'background-image:url(' + pages6[390] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 9.3%;left: 14.6%;width: 5.2%;"
                target="_blank"
                @click="openLink('https://www.doverstreetmarket.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7.4%; left: 5.6%; width: 11.2%"
                target="_blank"
                @click="openLink('https://www.doverstreetmarket.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[391] + ')'"></div>
            <div :style="'background-image:url(' + pages6[392] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 10.2%; right: 7.5%; width: 12%"
                target="_blank"
                @click="openLink('https://www.richardquinn.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 15.8%; right: 7.5%; width: 22%"
                target="_blank"
                @click="openLink('https://loverboy.net')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[393] + ')'"></div>
            <div :style="'background-image:url(' + pages6[394] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.5%; left: 7.5%; width: 9%"
                target="_blank"
                @click="openLink('https://www.dior.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[395] + ')'"></div>
            <div :style="'background-image:url(' + pages6[396] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; left: 13.8%; width: 8.5%"
                target="_blank"
                @click="openLink('https://www.moschino.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 14.6%; left: 13.8%; width: 8.5%"
                target="_blank"
                @click="openLink('https://www.valentino.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[397] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 12.8%; right: 6.2%; width: 21%"
                target="_blank"
                @click="openLink('https://www.notjustalabel.com/christopher-de-la-cruz')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; right: 6.2%; width: 13%"
                target="_blank"
                @click="openLink('https://alexandrasipa.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[398] + ')'"></div>
            <div :style="'background-image:url(' + pages6[399] + ')'"></div>
            <div :style="'background-image:url(' + pages6[400] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 10.3%; right: 9.2%; width: 12.2%"
                target="_blank"
                @click="openLink('https://us.louisvuitton.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 17.5%; right: 9.2%; width: 7.5%"
                target="_blank"
                @click="openLink('https://www.annakiki.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[401] + ')'">
              <a
                class="links articles2"
                style="bottom: 21.5%; right: 7.5%; width: 15%"
                target="_blank"
                @click="openLink('https://fengchenwang.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 8.5%; right: 7.5%; width: 12%"
                target="_blank"
                @click="openLink('https://simonerocha.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[402] + ')'"></div>
            <div :style="'background-image:url(' + pages6[403] + ')'"></div>
            <div :style="'background-image:url(' + pages6[404] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 17.8%; right: 9%; width: 10.5%"
                target="_blank"
                @click="openLink('https://www.robertwun.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 10.5%; right: 9%; width: 9%"
                target="_blank"
                @click="openLink('https://www.balenciaga.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[405] + ')'"></div>
            <div :style="'background-image:url(' + pages6[406] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 10.5%; right: 8.6%; width:5.5%"
                target="_blank"
                @click="openLink('https://www.gucci.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 19.8%; right: 8.6%; width: 15%"
                target="_blank"
                @click="openLink('https://www.albertaferretti.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[407] + ')'"></div>
            <div :style="'background-image:url(' + pages6[408] + ')'">
              <vue-player
                ref="video7"
                id="highBarnet"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-6%2Fmedia%2Fpg407_High_Barnet_video.m4v?alt=media&token=3a454165-a439-48b3-82ad-972c03d3118d"
                :poster="media[130]"
              ></vue-player>
              <a
                class="links articles2"
                style="bottom: 12.5%;left: 77.5%;width: 11%;font-size: 0.7em;border-bottom: none !important;"
                @click.prevent="playHighBarnet"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages6[409] + ')'"></div>
            <div :style="'background-image:url(' + pages6[410] + ')'"></div>
            <div :style="'background-image:url(' + pages6[411] + ')'"></div>
            <div :style="'background-image:url(' + pages6[412] + ')'">
              <a
                class="links articles2"
                style="bottom: 13%; left: 18.4%; width: 18%"
                target="_blank"
                @click="openLink('https://www.alexandrevauthier.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 9%;left: 16.4%;width: 24%;"
                target="_blank"
                @click="openLink('https://www.alexandrevauthier.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 11.2%; left: 23.4%; width: 22%"
                target="_blank"
                @click="openLink('https://albrightnyc.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 18.6%; left: 16%; width: 9%"
                target="_blank"
                @click="openLink('https://www.lynnpaik.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[413] + ')'">
              <a
                class="links articles2"
                style="bottom: 16.6%; right: 29.4%; width: 12.5%"
                target="_blank"
                @click="openLink('https://normakamali.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 14.6%; right: 16.4%; width: 18.5%"
                target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 9.2%; right: 34.4%; width: 5%"
                target="_blank"
                @click="openLink('http://www.sacai.jp/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 9.2%; right: 16.4%; width: 7%"
                target="_blank"
                @click="
                  openLink(
                    'https://www.ebay.com/itm/255223262314?hash=item3b6c7dec6a:g:944AAOSwRgBhjYae'
                  )
                "
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[414] + ')'"></div>
            <div :style="'background-image:url(' + pages6[415] + ')'"></div>
            <div :style="'background-image:url(' + pages6[416] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.2%; left:10%; width: 5.5%"
                target="_blank"
                @click="openLink('https://www.loewe.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[417] + ')'">
              <a
                class="links articles2"
                style="bottom: 18.3%; right: 6%; width: 10.2%"
                target="_blank"
                @click="openLink('https://www.marcjacobs.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 9%; right: 10%; width: 8.2%"
                target="_blank"
                @click="openLink('https://www.bachmai.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[418] + ')'"></div>
            <div :style="'background-image:url(' + pages6[419] + ')'">
              <a
                class="links articles2"
                style="bottom: 16.5%; right: 17%; width: 12%"
                target="_blank"
                @click="openLink('https://normakamali.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 9.2%; right: 17%; width: 12%"
                target="_blank"
                @click="openLink('https://www.ysl.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[420] + ')'"></div>
            <div :style="'background-image:url(' + pages6[421] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 20.5%; right: 18%; width: 18%"
                target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.4%; right: 18%; width: 12.4%"
                target="_blank"
                @click="openLink('https://www.ysl.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[422] + ')'"></div>
            <div :style="'background-image:url(' + pages6[423] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 12.8%; right: 6%; width: 9.2%"
                target="_blank"
                @click="openLink('https://www.balenciaga.com')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; right: 6%; width: 15%"
                target="_blank"
                @click="openLink('https://dolcegabbana.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[424] + ')'"></div>
            <div :style="'background-image:url(' + pages6[425] + ')'"></div>
            <div :style="'background-image:url(' + pages6[426] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 16.5%; left: 18.4%; width: 14%"
                target="_blank"
                @click="openLink('https://www.driesvannoten.com/  ')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 11%; left: 10.5%; width: 12.2%"
                target="_blank"
                @click="openLink('https://normakamali.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7.3%; left: 5.6%; width: 16%"
                target="_blank"
                @click="openLink('https://www.stellamccartney.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[427] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 14.6%; right: 5.8%; width: 17%"
                target="_blank"
                @click="openLink('http://hogan-mclaughlin.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 12.7%; right: 5.8%; width: 6%"
                target="_blank"
                @click="openLink('https://shop.hanrousa.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7.2%; right: 5.8%; width: 14.5%"
                target="_blank"
                @click="openLink('https://www.driesvannoten.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[428] + ')'"></div>
            <div :style="'background-image:url(' + pages6[429] + ')'"></div>
            <div :style="'background-image:url(' + pages6[430] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 15%; left: 31%; width: 8%"
                target="_blank"
                @click="openLink('https://burberry.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.5%; left: 22.5%; width: 11%"
                target="_blank"
                @click="openLink('https://threeasfour.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[431] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 16.5%; right: 19.5%; width: 5%"
                target="_blank"
                @click="openLink('https://www.gucci.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 14.6%; right: 6%; width: 5%"
                target="_blank"
                @click="openLink('https://www.gucci.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 9.1%; right: 28%; width: 16%"
                target="_blank"
                @click="openLink('https://www.stellamccartney.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom:9.3%; right: 6%; width: 8.5%"
                target="_blank"
                @click="openLink('https://www.cloakwardrobe.com/')"
              >clik</a>
              <a
                class="minilinks articles2"
                style="bottom: 7.3%; right: 6%; width: 28.5%"
                target="_blank"
                @click="openLink('https://www.cloakwardrobe.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[432] + ')'"></div>
            <div :style="'background-image:url(' + pages6[433] + ')'"></div>
            <div :style="'background-image:url(' + pages6[434] + ')'"></div>
            <div :style="'background-image:url(' + pages6[435] + ')'"></div>
            <div :style="'background-image:url(' + pages6[436] + ')'">
              <a
                class="minilinks articles2"
                style="bottom: 89.3%; right: 26.4%; width: 19.5%"
                target="_blank"
                @click="openLink('https://twitter.com/ZoeHanaMikuta')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[437] + ')'"></div>
            <div :style="'background-image:url(' + pages6[438] + ')'"></div>
            <div :style="'background-image:url(' + pages6[439] + ')'">
              <!-- Stockits left A-->
              <a
                class="links articles2"
                style="bottom:87.4%; left:7%; width: 13%;"
                target="_blank"
                @click="openLink('https://ahluwalia.world/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:83%  ; left:7%; width: 14.5%;"
                target="_blank"
                @click="openLink('https://www.albertaferretti.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:78.8%; left: 7%; width: 18%;"
                target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:74.6%; left: 7%; width: 14.5%;"
                target="_blank"
                @click="openLink('https://alexandrasipa.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:70.4%; left:7%; width: 18%;"
                target="_blank"
                @click="openLink('https://www.alexandrevauthier.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:66.2%; left:7%; width: 12%;"
                target="_blank"
                @click="openLink('http://albrightnyc.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:62%; left:7%; width: 10.5%;"
                target="_blank"
                @click="openLink('https://www.amiparis.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:57.7%; left:7%; width: 12%;"
                target="_blank"
                @click="openLink('https://angelchang.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:53.5%; left:7%; width: 10.5%;"
                target="_blank"
                @click="openLink('https://www.annakiki.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:49.2%; left:7%; width: 6.5%;"
                target="_blank"
                @click="openLink('https://area.nyc/collections/shoes')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:45.2%  ; left:7%; width: 10%;"
                target="_blank"
                @click="openLink('https://www.bachmai.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:40.8%; left:7%; width: 12%;"
                target="_blank"
                @click="openLink('https://www.balenciaga.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:36.6%; left:7%; width: 10%;"
                target="_blank"
                @click="openLink('https://www.balmain.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:32.4%; left:7%; width: 9%;"
                target="_blank"
                @click="openLink('https://www.berluti.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:28.2%; left: 7%; width: 11%"
                target="_blank"
                @click="openLink('https://www.bonnieclyde.la/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:24%  ; left: 7%; width: 14%"
                target="_blank"
                @click="openLink('https://www.bottegaveneta.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:19.8%; left: 7%; width: 17%"
                target="_blank"
                @click="openLink('https://www.brooklyngrooming.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:15.6%; left: 7%; width: 10%"
                target="_blank"
                @click="openLink('https://burberry.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:11.4% ; left: 7%; width: 11%"
                target="_blank"
                @click="openLink('https://www.calvinklein.us/en')"
              >clik</a>
              <!-- stockits right  A-->
              <a
                class="links articles2"
                style="bottom:87.4%; left:55.6%; width: 7%;"
                target="_blank"
                @click="openLink('https://cdlp.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:83%  ; left:55.6%; width: 8%;"
                target="_blank"
                @click="openLink('https://www.celine.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:78.8%; left:55.6%; width: 14%;"
                target="_blank"
                @click="openLink('https://wearechance.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:74.6%; left:55.6%; width: 8.5%;"
                target="_blank"
                @click="openLink('https://www.chanel.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:70.4%; left:55.6%; width: 9.5%;"
                target="_blank"
                @click="openLink('https://loverboy.net/clothing')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:66.2%; left:55.6%; width: 7.5%;"
                target="_blank"
                @click="openLink('https://www.chloe.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:62%  ; left:55.6%; width: 15%;"
                target="_blank"
                @click="openLink('https://www.cloakwardrobe.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:57.7%; left:55.6%; width: 13.5%;"
                target="_blank"
                @click="openLink('https://www.notjustalabel.com/christopher-de-la-cruz')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:53.5%; left:55.6%; width: 16.5%;"
                target="_blank"
                @click="openLink('https://www.church-footwear.com/us/en/women/collection/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:49.2%; left:55.6%; width: 7.8%;"
                target="_blank"
                @click="openLink('https://www.coach.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:45%  ; left:55.6%; width: 10%;"
                target="_blank"
                @click="openLink('https://www.converse.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:40.8%; left:55.6%; width: 6.5%;"
                target="_blank"
                @click="openLink('https://www.dior.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:36.6%; left:55.6%; width: 14%;"
                target="_blank"
                @click="openLink('https://dolcegabbana.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:32.4%; left:55.6%; width: 14.5%;"
                target="_blank"
                @click="openLink('https://www.driesvannoten.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 28.2%; left:55.6%; width: 14.5%"
                target="_blank"
                @click="openLink('https://fengchenwang.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 24%  ; left:55.6%; width: 7%"
                target="_blank"
                @click="openLink('https://www.gucci.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 19.8%; left:55.6%; width: 15%"
                target="_blank"
                @click="openLink('https://shop.hanrousa.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:15.6%; left:55.6%; width: 18%"
                target="_blank"
                @click="openLink('http://hogan-mclaughlin.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:11.4%  ; left:55.6%; width: 15%"
                target="_blank"
                @click="openLink('https://industrieafrica.com/collections/iamisigo')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[440] + ')'">
              <!-- stockits left B -->
              <a
                class="links articles2"
                style="bottom: 87.4%; left: 5.5%; width: 7.5%"
                target="_blank"
                @click="openLink('https://www.icicle.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:83.4%; left:5.5%; width: 14%"
                target="_blank"
                @click="openLink('https://www.isabelmarant.com')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:79%  ; left:5.5%; width: 12.5%"
                target="_blank"
                @click="openLink('https://www.isseymiyake.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:74.8%; left:5.5%; width: 7.5%"
                target="_blank"
                @click="openLink('https://www.jwpei.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:70.6%; left:5.5%; width: 10.8%"
                target="_blank"
                @click="openLink('https://livingkoa.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:66.4%; left:5.5%; width: 8%"
                target="_blank"
                @click="openLink('https://www.loewe.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:62.2%; left:5.5%; width: 15%"
                target="_blank"
                @click="openLink('https://us.louisvuitton.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:58%; left:5.5%; width: 10.5%;"
                target="_blank"
                @click="openLink('https://www.lynnpaik.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:53.7%; left:5.5%; width: 7.5%"
                target="_blank"
                @click="openLink('https://makua.co/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:49.5%; left:5.5%; width: 12%"
                target="_blank"
                @click="openLink('https://www.marcjacobs.com/')"
              >clik</a>

              <a
                class="links articles2"
                style="bottom:45.2%; left:5.5%; width: 9.6%;"
                target="_blank"
                @click="openLink('https://www.miumiu.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:41%  ; left:5.5%; width: 10.5%"
                target="_blank"
                @click="openLink('https://www.moschino.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:36.8%; left:5.5%; width: 12%"
                target="_blank"
                @click="openLink('http://www.mozhmozh.com/  ')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:32.6%; left:5.5%; width: 11%;"
                target="_blank"
                @click="openLink(' https://nisaitoyou.com/ ')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:28.4%; left:5.5%; width: 18%;"
                target="_blank"
                @click="openLink('https://doverstreetmarket.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:24.2%; left:5.5%; width: 14%"
                target="_blank"
                @click="openLink('https://normakamali.com/.com/  ')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:20%  ; left:5.5%; width: 15%"
                target="_blank"
                @click="openLink('https://paperprojectny.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:15.8%; left:5.5%; width: 12.5%"
                target="_blank"
                @click="openLink('https://yourparade.com/  ')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:11.6%; left:5.5%; width: 8%"
                target="_blank"
                @click="openLink('https://www.prada.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:7.4% ; left:5.5%; width: 15.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/rahemurrahman/')"
              >clik</a>
              <!-- stockits right B -->
              <a
                class="links articles2"
                style="bottom: 87.4%; left: 54.2%; width: 13%"
                target="_blank"
                @click="openLink('https://www.ralphlauren.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:83.4%; left:54.2%; width: 14%;"
                target="_blank"
                @click="openLink('https://www.richardquinn.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:79%  ; left:54.2%; width: 10%;"
                target="_blank"
                @click="openLink('https://www.rickowens.eu/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:74.8%; left:54.2%; width: 12%;"
                target="_blank"
                @click="openLink('https://www.robertwun.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:70.6%; left:54.2%; width: 6%;"
                target="_blank"
                @click="openLink('http://www.sacai.jp/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:66.4%; left:54.2%; width: 6%;"
                target="_blank"
                @click="openLink('https://www.ysl.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:62.2%; left:54.2%; width: 13%;"
                target="_blank"
                @click="openLink('https://www.saltandstone.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:58%  ; left:54.2%; width: 11.5%;"
                target="_blank"
                @click="openLink('https://www.sayebrand.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:53.7%; left:54.2%; width: 13%;"
                target="_blank"
                @click="openLink('https://simonerocha.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:49.5%; left:54.2%; width: 15.5%;"
                target="_blank"
                @click="openLink('https://www.stellamccartney.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:45.2%; left:54.2%; width: 12%;"
                target="_blank"
                @click="openLink('https://www.sunniesface.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:41%  ; left:54.2%; width: 7%;"
                target="_blank"
                @click="
                  openLink(
                    'https://www.ebay.com/itm/255223262314?hash=item3b6c7dec6a:g:944AAOSwRgBhjYae'
                  )
                "
              >clik</a>
              <a
                class="links articles2"
                style="bottom:36.8%; left:54.2%; width: 10.5%;"
                target="_blank"
                @click="openLink('https://www.svnrshop.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:32.6%; left:54.2%; width: 12%;"
                target="_blank"
                @click="openLink('https://threeasfour.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:28.4%; left:54.2%; width: 10.8%;"
                target="_blank"
                @click="openLink('https://www.valentino.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 24.2%; left:54.2%; width: 16%"
                target="_blank"
                @click="openLink('https://winnienewyork.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 20%  ; left:54.2%; width: 8.8%"
                target="_blank"
                @click="openLink('https://xuyoni.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom: 15.8%; left:54.2%; width: 12.8%"
                target="_blank"
                @click="openLink('https://yanyanknits.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:11.6%; left:54.2%; width: 14%"
                target="_blank"
                @click="openLink('https://zankovstudio.com/')"
              >clik</a>
              <a
                class="links articles2"
                style="bottom:7.4%  ; left:54.2%; width: 9%"
                target="_blank"
                @click="openLink('https://www.zouxou.com/')"
              >clik</a>
            </div>
            <div :style="'background-image:url(' + pages6[441] + ')'"></div>
            <div :style="'background-image:url(' + pages6[442] + ')'"></div>
            <div :style="'background-image:url(' + pages6[443] + ')'"></div>
            <div :style="'background-image:url(' + pages6[444] + ')'"></div>
            <div :style="'background-image:url(' + pages6[445] + ')'"></div>
          </div>
          <div class="flipbook-video video-wtsu" id="video-wtsu" v-show="verWtsu">
            <b-embed
              type="video"
              :src="infoModalWtsu.src"
              id="videoWtsu"
              autoplay
              allow="autoplay"
              :controls="false"
              allowfullscreen
            ></b-embed>
          </div>
        </div>
        <index v-if="index"></index>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "@/lib/turn.js";
import "@/lib/zoom.js";
import "@/lib/hash.js";
import index from "./Index";
import loader from "../../containers/loader";
import vuePlayer from "@algoz098/vue-player";

import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    index,
    loader,
    vuePlayer,
    // navIndex
  },
  data() {
    return {
      infoModalWtsu: {
        src: "",
        isPlay: false,
      },
      verWtsu: false,
    };
  },

  async beforeMount() {
    
    await this.loadMagazine6();
   
  },
  mounted() {
    function loadApp() {
      $("#canvas").fadeIn(4000);

      var o = $(".flipbook");
      0 != o.width() && 0 != o.height()
        ? (o.turn({
          width: 1680,
          height: 1080,
          duration: 4000,
          acceleration: !isChrome(),
          gradients: !0,
          autoCenter: !0,
          elevation: 200,
          when: {
            turning: function (o, i, n) {
              var e = $(this),
                a = e.turn("page");
              e.turn("pages");
              $("#video-wtsu").hide();
              const media = document.getElementById("videoWtsu");
              media.pause();

              disableControls(i),
                $(".thumbnails .page-" + a)
                  .parent()
                  .removeClass("current"),
                $(".thumbnails .page-" + i)
                  .parent()
                  .addClass("current");
            },
            turned: function (o, i, n) {
              disableControls(i),
                $(this).turn("center"),
                1 == i && $(this).turn("peel", "br");
            },
            missing: function (o, i) {
              for (var n = 0; n < i.length; n++) addPage(i[n], $(this));
            },
          },
        }),
          $(".flipbook-viewport").zoom({
            flipbook: $(".flipbook"),
            max: function () {
              return largeMagazineWidth() / $(".flipbook").width();
            },
            when: {
              swipeLeft: function () {
                $(this)
                  .zoom("flipbook")
                  .turn("next");
              },
              swipeRight: function () {
                $(this)
                  .zoom("flipbook")
                  .turn("previous");
              },
              resize: function (o, i, n, e) {
                1 == i ? loadSmallPage(n, e) : loadLargePage(n, e);
              },
              zoomIn: function () {
                $(".thumbnails").hide(),
                  $(".made").hide(),
                  $(".flipbook")
                    .removeClass("animated")
                    .addClass("zoom-in"),
                  $(".zoom-icon")
                    .removeClass("zoom-icon-in")
                    .addClass("zoom-icon-out"),
                  window.escTip || $.isTouch || (escTip = !0);
              },
              zoomOut: function () {
                $(".exit-message").hide(),
                  $(".made").fadeIn(),
                  $(".zoom-icon")
                    .removeClass("zoom-icon-out")
                    .addClass("zoom-icon-in"),
                  setTimeout(function () {
                    $(".flipbook")
                      .addClass("animated")
                      .removeClass("zoom-in"),
                      resizeViewport();
                  }, 0);
              },
            },
          }),
          // pasar hojas con flechas

          $(document).keydown(function (e) {
            var options = $(".flipbook").turn("options");

            var previous = 37,
              next = 39,
              esc = 27;

            switch (e.keyCode) {
              case previous:
                // left arrow
                $(".flipbook").turn("previous");
                e.preventDefault();
                break;

              case next:
                //right arrow
                $(".flipbook").turn("next");
                e.preventDefault();
                break;

              case esc:
                $(".flipbook").turn("size", options.width, options.height);
                e.preventDefault();

                break;
            }
          }),
          $(window)
            .resize(function () {
              resizeViewport();
            })
            .bind("orientationchange", function () {
              resizeViewport();
            }),
          // $.isTouch ? $(".flipbook").bind("touchstart", regionClick) : $(".flipbook").click(regionClick),
          resizeViewport(),
          $(".flipbook").addClass("animated"))
        : setTimeout(loadApp, 10);
    }

    $(".zoom-icon")
      .bind("mouseover", function () {
        $(this).hasClass("zoom-icon-in") && $(this).addClass("zoom-icon-in-hover"),
          $(this).hasClass("zoom-icon-out") && $(this).addClass("zoom-icon-out-hover");
      })
      .on("mouseout", function () {
        $(this).hasClass("zoom-icon-in") && $(this).removeClass("zoom-icon-in-hover"),
          $(this).hasClass("zoom-icon-out") && $(this).removeClass("zoom-icon-out-hover");
      })
      .on("click", function () {
        toggleFullscreen();
      }),
      $("#canvas").hide();

    //FUNCTIONS TURNJS
    function resizeViewport() {
      var width = $(window).width(),
        height = $(window).height(),
        options = $(".flipbook").turn("options");

      $(".flipbook").removeClass("animated");

      $(".flipbook-viewport")
        .css({
          width: width,
          height: height,
        })
        .zoom("resize");

      if ($(".flipbook").turn("zoom") == 1) {
        var bound = calculateBound({
          width: options.width,
          height: options.height,
          boundWidth: Math.min(options.width, width),
          boundHeight: Math.min(options.height, height),
        });

        if (bound.width % 2 !== 0) bound.width -= 1;

        if (bound.width != $(".flipbook").width() || bound.height != $(".flipbook").height()) {
          $(".flipbook").turn("size", bound.width, bound.height);

          if ($(".flipbook").turn("page") == 1) $(".flipbook").turn("peel", "br");

          $(".next-button").css({
            height: bound.height,
            backgroundPosition: "-38px " + (bound.height / 2 - 32 / 2) + "px",
          });
          $(".previous-button").css({
            height: bound.height,
            backgroundPosition: "-4px " + (bound.height / 2 - 32 / 2) + "px",
          });
        }

        $(".flipbook").css({
          top: -bound.height / 2,
          left: -bound.width / 2,
        });
        $(".flipbook-video").css({
          width: bound.width,
          height: bound.height,
          top: -bound.height / 2,
          left: -bound.width / 2,
          padding: 15,
        });
      }

      var magazineOffset = $(".flipbook").offset(),
        boundH = height - magazineOffset.top - $(".flipbook").height(),
        marginTop = (boundH - $(".thumbnails > div").height()) / 2;

      if (marginTop < 0) {
        $(".thumbnails").css({
          height: 1,
        });
      } else {
        $(".thumbnails").css({
          height: boundH,
        });
        $(".thumbnails > div").css({
          marginTop: marginTop,
        });
      }

      if (magazineOffset.top < $(".made").height()) $(".made").hide();
      else $(".made").show();

      $(".flipbook").addClass("animated");
    }

    function isChrome() {
      return navigator.userAgent.indexOf("Chrome") != -1;
    }

    function calculateBound(d) {
      var bound = {
        width: d.width,
        height: d.height,
      };

      if (bound.width > d.boundWidth || bound.height > d.boundHeight) {
        var rel = bound.width / bound.height;

        if (d.boundWidth / rel > d.boundHeight && d.boundHeight * rel <= d.boundWidth) {
          bound.width = Math.round(d.boundHeight * rel);
          bound.height = d.boundHeight;
        } else {
          bound.width = d.boundWidth;
          bound.height = Math.round(d.boundWidth / rel);
        }
      }

      return bound;
    }

    function toggleFullscreen(elem) {
      var options = $(".flipbook").turn("options");

      elem = elem || document.documentElement;
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
      ) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        }
      }
    }

    function disableControls(page) {
      if (page == 1) $(".previous-button").hide();
      else $(".previous-button").show();

      if (page == $(".flipbook").turn("pages")) $(".next-button").hide();
      else $(".next-button").show();
    }

    function loadSmallPage(page, pageElement) {
      var img = pageElement.find("img");

      img.css({
        width: "100%",
        height: "100%",
      });

      img.unbind("load");
    }
    // large page
    function loadLargePage(page, pageElement) {
      var img = $("<div />");

 
      img.load(function () {
        var prevImg = pageElement.find("img");

        $(this).css({
          width: "100%",
          height: "100%",
        });
        $(this).appendTo(pageElement);
        prevImg.remove();
      });
    }
    loadApp();
    this.playAudio();
  },
  methods: {
    //modal embed

    cambiarEstado(newEstado) {
      this.estado = newEstado;
      if (newEstado == "/index") {
        this.setClass(true);
        this.pause();
        this.ver = false;
      } else {
        this.$router.push(this.estado);
        this.setClass(false);
        this.pause();
        this.ver = false;
      }
    },
 
    onPlayerReadyWtsu(reproducir) {
      this.infoModalWtsu.isPlay = true;
      this.infoModalWtsu.src = reproducir;
      /* this.infoModalWtsu.poster = mini; */
      setTimeout(() => {
        const media = document.getElementById("videoWtsu");
        media.load();
        media.play();
        this.infoModalWtsu.isPlay = true;
        this.verWtsu = true;
      }, 100);
    },
    openLink(url) {
      window.open(url);
    },
    openBook() {
      let route = this.$router.resolve("/colorbook/6"); // This also works.
      window.open(route.href, "_blank");
    },

    playAudio() {
      setTimeout(() => {
        this.audioI6.isPlaying = true;
        this.audioI6.file.play();
      }, 6500);
    },
    playCover(cover) {
      this.verPlayIssue6(true);
      cover.file.play();
    },

    pauseCover(cover) {
      this.verPlayIssue6(false);
      cover.file.pause();
    },

    pause() {
      if (this.audioI6.isPlaying == true) {
        this.audioI6.file.pause();
        this.verPlayIssue6(false);
      }
      if (this.infoModalWtsu.isPlay == true) {
        const media = document.getElementById("videoWtsu");
        media.pause();
        this.verWtsu = false;
        this.infoModalWtsu.isPlay = false;
      }

      if (this.$refs.video1.playing == true) {
        this.$refs.video1.playing == false;
        this.$refs.video1.$refs.video.pause();
      }
      if (this.$refs.video2.playing == true) {
        this.$refs.video2.playing == false;
        this.$refs.video2.$refs.video.pause();
      }
      if (this.$refs.video3.playing == true) {
        this.$refs.video3.playing == false;
        this.$refs.video3.$refs.video.pause();
      }
      if (this.$refs.video4.playing == true) {
        this.$refs.video4.playing == false;
        this.$refs.video4.$refs.video.pause();
      }
      if (this.$refs.video5.playing == true) {
        this.$refs.video5.playing == false;
        this.$refs.video5.$refs.video.pause();
      }
      if (this.$refs.video6.playing == true) {
        this.$refs.video6.playing == false;
        this.$refs.video6.$refs.video.pause();
      }
      if (this.$refs.video7.playing == true) {
        this.$refs.video7.playing == false;
        this.$refs.video7.$refs.video.pause();
      }
    },
    playMusicMachines1() {
      this.$refs.video1.$refs.video.load();
      this.$refs.video1.$refs.video.play();
    },
    playMusicMachines2() {
      this.$refs.video2.$refs.video.load();
      this.$refs.video2.$refs.video.play();
    },
    playMidwest() {
      this.$refs.video3.$refs.video.load();
      this.$refs.video3.$refs.video.play();
    },
    playDamsonIdris() {
      //pg158
      this.$refs.video4.$refs.video.load();
      this.$refs.video4.$refs.video.play();
    },
    playSnowfall() {
      this.$refs.video5.$refs.video.load();
      this.$refs.video5.$refs.video.play();
    },
    playRoma() {
      this.$refs.video6.$refs.video.load();
      this.$refs.video6.$refs.video.play();
    },
    playHighBarnet() {
      this.$refs.video7.$refs.video.load();
      this.$refs.video7.$refs.video.play();
    },
    pageNext() {
      $(".flipbook").turn("next");
      this.pause();
    },
    pagePrev() {
      $(".flipbook").turn("previous");
      this.pause();
    },

    ...mapActions("magazine", ["loadMagazine6"]),
    ...mapMutations("magazine", ["setClass", "loadSmallPage", "loadLargePage", "verPlayIssue6"]),
  },
  computed: {
    ...mapState("magazine", ["index", "pages6", "loading", "media", "audioI6"]),
  },
};
</script>

<style lang="scss">
video {
  object-fit: cover !important;
}
.cover-button {
  bottom: 40%;
  position: absolute;
  right: 12%;
  width: 6%;
  cursor: pointer;
}
#playerModal .vue-video-player-controls {
  max-height: 30px;
  display: flex;
  left: 15% !important;
  right: 15% !important;
  padding: 5px;
  position: absolute;
  bottom: 17% !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
.musicMachines1 {
  position: absolute;
  top: 26%;
  margin-left: 7%;
  width: 88%;
  height: 45%;
  z-index: 12;
}
#musicMachines1 {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }
  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}
.music2 {
  position: absolute;
  top: 26%;
  margin-left: 5%;
  width: 88%;
  height: 45%;
  z-index: 12;
}
#music2 {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }
  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}
.midwest {
  position: absolute;
  top: 26%;
  margin-left: 5%;
  width: 88%;
  height: 45%;
  z-index: 12;
}
#midwest {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }
  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}
.damson {
  position: absolute;
  top: 27%;
  margin-left: 7%;
  width: 89%;
  height: 46%;
  z-index: 12;
}
#damson {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }
  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}
.snowfall {
  position: absolute;
  top: 26%;
  margin-left: 5%;
  width: 89%;
  height: 45%;
  z-index: 12;
}
#snowfall {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }
  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}
.roma {
  position: absolute;
  top: 26%;
  margin-left: 5%;
  width: 89%;
  height: 45%;
  z-index: 12;
}
#roma {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }
  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}
#highBarnet {
  position: absolute;
  top: 0%;
  margin-left: 0%;
  width: 100%;
  height: 83%;
  z-index: 12;
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }
  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}

.vue-video-player-controls {
  display: none !important;
}
.start-button {
  width: auto;
  height: auto;
  border: none;
  border-radius: none;
  background-color: rgba(0, 0, 0, 0) !important;
  cursor: none;
}
.vue-player-time-control {
  position: absolute;
  top: -5px;
  left: 0;
  padding-top: 0;
  color: rgba(255, 255, 255, 0.3) !important;
  display: block;
}
.button {
  width: 35px;
  border: none !important;
  color: rgba(0, 0, 0, 0) !important;
  background-color: transparent;
}

.minilinksblack {
  position: absolute;
  cursor: pointer;
  color: black;
  font-family: 'lemon_milkregular';
  font-style: italic;
  -webkit-font-smoothing: antialiased;
  font-size: 0.8em;
  z-index: 100;
  text-decoration: underline;
}
.wtsu_left {
  position: absolute;
  top: 0%;
  left: 0.2%;
  width: 8%;
  height: 8%;
  z-index: 0;
}
.wtsu_right {
  position: absolute;
  top: 0%;
  right: 92%;
  width: 8%;
  height: 8%;
  z-index: 0;
}
//Pg 244-245 videoWtsu
.video-wtsu {
  .embed-responsive {
    position: absolute;
    z-index: 1000;
    width: 74%;
    height: 69%;
    top: 14.5%;
    left: 14.6%;
  }
}
</style>
